import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface ModalState {
    form: {
        download: boolean,
        open: boolean,
        title: string,
        text: string | null
    },
    complated: boolean,
    link: string | null
}

const initialState: ModalState = {
    form: {
        download: false,
        open: false,
        title: '',
        text: null
    },
    complated: false,
    link: null
};

const modalSlice = createSlice({
    name: "modal",
    initialState,
    reducers: {
        requestFormModalOpen(
            state,
            action: PayloadAction<{
                title: string;
                download?: boolean;
                text?: string;
                link?: string;
            }>
        ) {
            state.form.open = true;
            state.form.title = action.payload.title;

            state.form.text = action.payload.text ?? null;
            state.form.download = action.payload.download ?? false;
            state.link = action.payload.link ?? null;
        },
        requestFormModalClose(state) {
            state.form.open = false;
            state.form.title = '';
            state.form.text = null;
        },
        complatedModalOpen(state, action: PayloadAction<string | undefined>) {
            state.complated = true;
            if(action.payload){
                state.form.download = true;
                state.link = action.payload;
            }
        },
        complatedModalClose(state) {
            state.form.download = false;
            if(state.link)
                state.link = null;

            state.complated = false;
            
        },
    },
});

export const { requestFormModalClose, requestFormModalOpen, complatedModalOpen, complatedModalClose } = modalSlice.actions;
export default modalSlice.reducer;
